import Icon from '@ant-design/icons';

// Check-square: an outlined square (12.5px, inset within a 16px box) with a checkmark inside.
const AllTasksSvg = (props: any) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g transform="translate(1.75 1.75)">
      <path
        d="M12 0H0.5C0.223437 0 0 0.223437 0 0.5V12C0 12.2766 0.223437 12.5 0.5 12.5H12C12.2766 12.5 12.5 12.2766 12.5 12V0.5C12.5 0.223437 12.2766 0 12 0ZM11.375 11.375H1.125V1.125H11.375V11.375Z"
        fill="currentColor"
      />
    </g>
    <g transform="translate(4.8 5.52)">
      <path
        d="M1.97051 4.76094C2.0165 4.82513 2.07713 4.87744 2.14738 4.91352C2.21762 4.9496 2.29545 4.96843 2.37442 4.96843C2.45339 4.96843 2.53122 4.9496 2.60146 4.91352C2.6717 4.87744 2.73233 4.82513 2.77832 4.76094L6.06895 0.198438C6.12832 0.115625 6.06895 0 5.96739 0H5.23457C5.0752 0 4.92364 0.0765623 4.82989 0.207812L2.3752 3.61406L1.2627 2.07031C1.16895 1.94062 1.01895 1.8625 0.85801 1.8625H0.125198C0.0236354 1.8625 -0.0357396 1.97812 0.0236354 2.06094L1.97051 4.76094Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export const AllTasksIcon = (props: any) => <Icon component={AllTasksSvg} {...props} />;
